import { render, staticRenderFns } from "./LinkPromotionsList.vue?vue&type=template&id=288a3642"
import script from "./LinkPromotionsList.vue?vue&type=script&lang=js"
export * from "./LinkPromotionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports